export default function isElementInDom(target: HTMLElement): boolean {
  return !!target.getClientRects().length
}
